import { InjectionToken } from '@angular/core';

export interface FtsConfig {
  ftsClient: string;
  webSocketHost?: string;
}

export const FTS_CONFIG = new InjectionToken<FtsConfig>('fts.config');
